import { useState, useEffect, useRef } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Reviews.css';

export default function Reviews() {
    const { t, language } = useLanguage();

    const reviewsData = [
        { id: 1, name: "Thomas M.", textFr: "Meilleur barbershop de Malakoff ! L'équipe est au top, toujours à l'écoute. Ma coupe est parfaite à chaque fois.", textEn: "Best barbershop in Malakoff! The team is great, always attentive. My haircut is perfect every time." },
        { id: 2, name: "Karim B.", textFr: "Un service impeccable et une ambiance très agréable. Je recommande vivement pour la barbe et la coupe.", textEn: "Impeccable service and a very pleasant atmosphere. Highly recommend for beard and haircut." },
        { id: 3, name: "Lucas D.", textFr: "Première visite et je suis conquis. Accueil chaleureux, travail soigné. J'ai trouvé mon barbier !", textEn: "First visit and I'm won over. Warm welcome, careful work. I found my barber!" },
        { id: 4, name: "Mehdi A.", textFr: "Rapport qualité-prix imbattable. Les gars sont pros et sympas. Je viens tous les mois depuis 2 ans.", textEn: "Unbeatable value for money. The guys are professional and friendly. I've been coming every month for 2 years." },
        { id: 5, name: "Antoine L.", textFr: "Enfin un salon où on prend le temps de bien faire. Ma barbe n'a jamais été aussi bien taillée.", textEn: "Finally a salon where they take time to do things right. My beard has never looked so good." },
        { id: 6, name: "Youssef K.", textFr: "Ambiance relax, équipe au top et résultat toujours nickel. Que demander de plus ?", textEn: "Relaxed atmosphere, great team and always perfect results. What more could you ask for?" },
        { id: 7, name: "Pierre C.", textFr: "Je suis client fidèle depuis l'ouverture. La qualité est constante, le service excellent.", textEn: "I've been a loyal customer since they opened. Consistent quality, excellent service." },
        { id: 8, name: "Omar S.", textFr: "Dégradé parfait à chaque fois. Les barbiers sont de vrais artistes. Merci Alpha Barber !", textEn: "Perfect fade every time. The barbers are true artists. Thanks Alpha Barber!" },
        { id: 9, name: "Maxime R.", textFr: "Super expérience ! Ponctualité, professionnalisme et résultat au-delà de mes attentes.", textEn: "Great experience! Punctuality, professionalism and results beyond my expectations." },
        { id: 10, name: "Samir H.", textFr: "Je recommande à 100%. Meilleur rapport qualité-prix du coin. L'équipe est vraiment sympa.", textEn: "100% recommend. Best value in the area. The team is really nice." },
        { id: 11, name: "Julien F.", textFr: "Excellent salon ! J'y emmène aussi mon fils, il adore. Service irréprochable.", textEn: "Excellent salon! I also bring my son, he loves it. Impeccable service." },
        { id: 12, name: "Rachid E.", textFr: "Toujours satisfait depuis 3 ans. Les coupes sont modernes et bien réalisées.", textEn: "Always satisfied for 3 years. The cuts are modern and well done." },
        { id: 13, name: "Nicolas G.", textFr: "Cadre moderne et agréable. Les barbiers sont à l'écoute et donnent de bons conseils.", textEn: "Modern and pleasant setting. The barbers listen and give good advice." },
        { id: 14, name: "Adrien P.", textFr: "Ma coupe préférée depuis des années. Professionnels, rapides et efficaces.", textEn: "My favorite haircut for years. Professional, fast and efficient." },
        { id: 15, name: "Bilal N.", textFr: "Service au top ! Ils prennent vraiment soin de leurs clients. Je recommande.", textEn: "Top service! They really take care of their customers. I recommend." },
        { id: 16, name: "Christophe V.", textFr: "Très bon accueil, travail soigné et prix corrects. Tout ce qu'il faut !", textEn: "Very good welcome, careful work and fair prices. Everything you need!" },
        { id: 17, name: "Hamza T.", textFr: "Le meilleur salon de la région. Équipe sympa et résultat toujours parfait.", textEn: "The best salon in the region. Nice team and always perfect results." },
        { id: 18, name: "David W.", textFr: "Enfin des pros qui savent ce qu'ils font. Ma barbe et ma coupe sont impeccables.", textEn: "Finally pros who know what they're doing. My beard and haircut are impeccable." },
        { id: 19, name: "Sofiane M.", textFr: "Ambiance conviviale et travail de qualité. Je ne changerais pour rien au monde.", textEn: "Friendly atmosphere and quality work. I wouldn't change for anything." },
        { id: 20, name: "Florian J.", textFr: "Découvert grâce à Treatwell et je comprends pourquoi ils sont si bien notés. Excellent !", textEn: "Discovered through Treatwell and I understand why they're so highly rated. Excellent!" }
    ];

    const [index, setIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);
    const [cardWidth, setCardWidth] = useState(296);
    const [isPaused, setIsPaused] = useState(false);
    const timeoutRef = useRef(null);
    const delay = 5000;

    const extendedReviews = [...reviewsData, ...reviewsData, ...reviewsData];

    useEffect(() => {
        const updateCardWidth = () => {
            const width = window.innerWidth;
            if (width <= 360) {
                setCardWidth(200 + 6);
            } else if (width <= 480) {
                setCardWidth(220 + 8);
            } else if (width <= 640) {
                setCardWidth(240 + 10);
            } else if (width <= 768) {
                setCardWidth(250 + 12);
            } else if (width <= 1024) {
                setCardWidth(260 + 16);
            } else {
                setCardWidth(280 + 16);
            }
        };

        updateCardWidth();
        window.addEventListener('resize', updateCardWidth);
        return () => window.removeEventListener('resize', updateCardWidth);
    }, []);

    useEffect(() => {
        resetTimeout();
        if (!isPaused) {
            timeoutRef.current = setTimeout(() => {
                setIndex((prevIndex) => prevIndex + 1);
            }, delay);
        }
        return () => resetTimeout();
    }, [index, isPaused]);

    useEffect(() => {
        if (index >= reviewsData.length * 2) {
            setTimeout(() => {
                setIsTransitioning(false);
                setIndex(reviewsData.length);
            }, 600);
        } else if (index === 0) {
            setTimeout(() => {
                setIsTransitioning(false);
                setIndex(reviewsData.length);
            }, 600);
        } else {
            if (!isTransitioning) setIsTransitioning(true);
        }
    }, [index, isTransitioning, reviewsData.length]);

    const resetTimeout = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    const handleNext = () => setIndex((prev) => prev + 1);
    const handlePrev = () => setIndex((prev) => prev - 1);

    const getTransform = () => {
        const offset = index * cardWidth;
        return `translateX(calc(50vw - ${offset}px - ${cardWidth / 2}px))`;
    };

    const getInitials = (name) => {
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    return (
        <section className="reviews-section" id="reviews">
            <div className="reviews-header">
                <span className="reviews-badge">{t('reviews.subtitle')}</span>
                <h2 className="reviews-title">{t('reviews.title')}</h2>
            </div>

            <div
                className="reviews-viewport"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                onTouchStart={() => setIsPaused(true)}
                onTouchEnd={() => setIsPaused(false)}
            >
                <div className="reviews-overlay overlay-left"></div>
                <div className="reviews-overlay overlay-right"></div>

                <button className="nav-btn prev-btn" onClick={handlePrev} aria-label="Précédent">
                    <FiChevronLeft size={28} />
                </button>
                <button className="nav-btn next-btn" onClick={handleNext} aria-label="Suivant">
                    <FiChevronRight size={28} />
                </button>

                <div
                    className="reviews-track"
                    style={{
                        transform: getTransform(),
                        transition: isTransitioning ? 'transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)' : 'none'
                    }}
                >
                    {extendedReviews.map((review, idx) => {
                        const isActive = idx === index;
                        const colorClass = `color-${(review.id % 5) + 1}`;

                        return (
                            <div
                                key={`${review.id}-${idx}`}
                                className={`review-card ${isActive ? 'active' : ''}`}
                            >
                                <div className="review-content">
                                    <div className="quote-icon">"</div>

                                    <div className="review-text-container">
                                        <p className="review-text">
                                            {language === 'fr' ? review.textFr : review.textEn}
                                        </p>
                                    </div>

                                    <div className="review-stars">
                                        {[...Array(5)].map((_, i) => (
                                            <span key={i} className="star">★</span>
                                        ))}
                                    </div>

                                    <div className="review-divider"></div>

                                    <div className="review-footer">
                                        <div className={`review-avatar ${colorClass}`}>
                                            <span className="avatar-initials">{getInitials(review.name)}</span>
                                        </div>

                                        <div className="review-info">
                                            <span className="review-author">{review.name}</span>
                                            <span className="review-verified">
                                                <span className="verified-icon">✓</span>
                                                {t('reviews.verified')}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {isActive && (
                                    <div className={`progress-bar ${isPaused ? 'paused' : ''}`}></div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="reviews-badge-bottom">
                <span className="badge-star">⭐</span>
                <span className="badge-text">Top Rated Treatwell 2025</span>
            </div>
        </section>
    );
}